import React from 'react';
import styles from '../App.module.css';

const getErrorClass = (errors, fieldName) => {
  const hasError = !!errors?.[fieldName];
  return hasError ? styles.inputError : '';
};

const InputField = ({ name, value, onChange, errors, multiline, style = {}, ...rest }) => {
  const commonProps = {
    name,
    value,
    onChange,
    className: getErrorClass(errors, name),
    style: {
      width: '100%',
      padding: '10px',
      fontSize: '1rem',
      borderRadius: '4px',
      resize: 'vertical',
      ...style,
    },
    ...rest,
  };

  return (
    <>
      {multiline ? (
        <textarea {...commonProps} rows={4} />
      ) : (
        <input {...commonProps} />
      )}
      {errors?.[name] && (
        <span style={{ color: 'red', fontSize: '0.9rem', marginTop: '-8px', marginBottom: '8px' }}>
          {errors[name]}
        </span>
      )}
    </>
  );
};

export default InputField;
